import React from "react";
import {
  Button,
  Calendar,
  CalendarCell,
  CalendarGrid,
  DateInput,
  DatePicker,
  DateSegment,
  Dialog,
  Group,
  Heading,
  Label,
  Popover,
} from "react-aria-components";
import "./DatePicker.scss";
import { observer } from "mobx-react";
import Icon from "shared/Icon";

// see https://react-spectrum.adobe.com/react-aria/DatePicker.html#datepicker
export default observer(function AriaDatePicker(props) {
  return (
    <DatePicker
      hideTimeZone={true}
      shouldForceLeadingZeros={true}
      hourCycle={24}
      {...props.dateField}
    >
      <Group>
        {props.label && <Label>{props.label}</Label>}
        <DateInput {...props.input}>{renderDateSegment}</DateInput>
        <Button>
          <Icon symbol="calendar" />
        </Button>
      </Group>
      <Popover>
        <Dialog>
          <Calendar>
            <header>
              <Button slot="previous">◀</Button>
              <Heading />
              <Button slot="next">▶</Button>
            </header>
            <CalendarGrid>
              {(date) => <CalendarCell date={date} />}
            </CalendarGrid>
          </Calendar>
        </Dialog>
      </Popover>
    </DatePicker>
  );
});

export function renderDateSegment(segment) {
  let { text, type } = segment;
  if (type === "month" || type === "day") {
    text = text.padStart(2, 0);
  }
  return <DateSegment segment={segment}>{text}</DateSegment>;
}
